import { Platform, StyleSheet } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'

/** Glassmorphic straddling tab bar (Claude Design handoff). Dark translucent shell with an accent pill. */
export const getCompetitionTabBarStyles = (theme: Theme, accent: string) =>
  StyleSheet.create({
    bar: {
      flexDirection: 'row',
      backgroundColor: 'rgba(20,12,38,0.92)',
      borderRadius: 16,
      padding: 5,
      borderWidth: 1,
      borderColor: 'rgba(255,255,255,0.08)',
      ...(Platform.OS === 'web'
        ? ({
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            boxShadow: '0 8px 22px rgba(0,0,0,0.5)',
          } as never)
        : {
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 8 },
            shadowOpacity: 0.5,
            shadowRadius: 22,
            elevation: 10,
          }),
    },
    tab: {
      flex: 1,
      borderRadius: 11,
      paddingVertical: 9,
      paddingHorizontal: 2,
      alignItems: 'center',
      justifyContent: 'center',
    },
    tabActive: {
      backgroundColor: accent,
      ...(Platform.OS === 'web'
        ? ({ boxShadow: '0 2px 8px rgba(0,0,0,0.35)' } as never)
        : {
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.35,
            shadowRadius: 8,
            elevation: 3,
          }),
    },
    tabPressed: {
      opacity: 0.85,
    },
    label: {
      fontSize: 11.5,
      fontWeight: '600',
      letterSpacing: -0.1,
      color: 'rgba(255,255,255,0.72)',
      textAlign: 'center',
    },
    labelActive: {
      fontWeight: '800',
      color: theme.onPrimary,
    },
  })
